import { render, staticRenderFns } from "./viewDis.vue?vue&type=template&id=a5b5b10c"
import script from "./viewDis.vue?vue&type=script&lang=js"
export * from "./viewDis.vue?vue&type=script&lang=js"
import style0 from "./viewDis.vue?vue&type=style&index=0&id=a5b5b10c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports